var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlace1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M0 0h32v32H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.596 4.805H7.476C5.487 15.784 11.82 19.743 14.81 20.974v3.289h-2.777a.861.861 0 00-.604.25.861.861 0 00-.25.605v1.454h9.638v-1.454a.861.861 0 00-.25-.605.86.86 0 00-.605-.25h-2.766V20.99c2.908-1.214 9.181-5.157 7.4-16.19v.005z",
    fill: "#FFB600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.74 8.728h-4.258a18.11 18.11 0 01-.087 1.671h2.598a5.485 5.485 0 01-3.693 4.406 12.525 12.525 0 01-1.073 1.993A7.207 7.207 0 0028.8 9.615c0-.305-.027-.599-.06-.893v.006zM5.008 10.397h2.57c-.049-.533-.07-1.089-.065-1.671H3.26c-.038.294-.06.588-.06.893a7.211 7.211 0 006.519 7.177 12.37 12.37 0 01-1.084-2.015 5.48 5.48 0 01-3.627-4.384z",
    fill: "#FFB600"
  })));
}
export default SvgPlace1;